import { get } from 'lodash'
import { ACTIVITY_CATEGORIES } from 'constants/enums'

export default function(fields = {}) {
  let model = {
    ...fields,
    id: undefined,
    award: undefined,
    logs: undefined,
    activityApprovalTask: undefined,
    activityAssessmentRequestAction: undefined,
    activityAssessmentAction: undefined,
    activitySignoffRequestAction: undefined,
    activitySignoffAction: undefined,
    activityApprovalAction: undefined,
    activitySignoffTask: undefined,
    otherName: undefined,
    version: undefined,
    activityCategory: {
      ...fields.activityCategory,
      version: undefined
    }
  }

  if (get(fields, 'activityCategory.id') === ACTIVITY_CATEGORIES.other.id) {
    model = {
      ...model,
      activityCategory: {
        ...model.activityCategory,
        activitySection: get(fields, 'activitySection'),
        userDefined: true,
        id: undefined,
        version: undefined
      }
    }
  }

  return model
}
